<template>
  <va-create-layout>
    <feed-storages-form :title="title" :item="item"></feed-storages-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
